import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return `v1/stock-pnl/realized/daily`;
}

/**
 * @typedef {import('./typedefs').PnlDailyResponse}  PnlDailyResponse
 * @typedef {import('@helpers/fetcher').FetchResponse<PnlDailyResponse>} Response
 */

/**
 * @param {string} url
 * @param {import('./typedefs').AccountType} accountType
 * @param {string} date
 * @returns
 */
function callbackFetch(url, accountType, date) {
  return async () => {
    try {
      /** @type {Response} */
      const res = await fetcher.get(url, {
        params: { type: accountType, date },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {import('./typedefs').AccountType} accountType
 * @param {string} date
 */
export default function fetch(accountType, date) {
  const url = getUrl();
  const cb = callbackFetch(url, accountType, date);
  const key = [url, accountType, date];

  return { cb, key };
}
